<!--
/**
* @description: 商家中心 -- 拼多多管理 -- 限价价盘
* @author: 张伟
* @time: 2024-07-19 10:49:20
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-card>
      <query-form :data="formData" titleWidth="100px" :form="dataForm.query" @search="handleSearch" @reset="handleReset"></query-form>
      <div style="margin-bottom: 10px;text-align: right">
        <y-upload-file v-if="roleType==='01'" acceptType=".xls,.xlsx" title="价盘导入" @change="valueChange" ref="uploadEle">
          <y-button>价盘导入</y-button>
        </y-upload-file>
        <y-button style="margin-left:12px" buttonType="default" @click="exportData">价盘导出</y-button>
        <k-button v-if="roleType==='01'" tag="a" href="/file/拼多多限价价盘导入模板.xlsx" target="_blank" type="default">模板下载</k-button>
      </div>
      <query-table ref="yTable" :initColumns="initColumns" :dataForm="dataForm" @loadingClose="isLoading = false"
                   @loadingOpen="isLoading = true"></query-table>
    </y-card>
  </y-view>
</template>
<script>
import {
  MALL_CODEPRICELIMIT_IMPORTRULE,
  MALL_CODEPRICELIMIT_LIST,
  MALL_GETSHOPID,
  MALL_CODEPRICELIMIT_EXPORTRULE
} from '@/assets/modules/pinduooApiList';


export default {
  data() {
    return {
      isSaving: false,
      isLoading: false,
      formData: [
        {
          typeCode: 'select',
          title: '店铺名称',
          name: 'shopId',
          placeholder: '请选择店铺名称',
          vname: 'shopName',
          sname: 'shopName',
          kname: 'shopId',
          optionData: []
        },
        { typeCode: 'input', title: '商品编码', name: 'baseCode', placeholder: '请输入商品编码' }
      ],
      dataForm: {
        baseUrl: window.__CONFIG__.pinduoo_url,
        url: MALL_CODEPRICELIMIT_LIST,
        tableH: 'calc(100vh - 258px)',
        rightFixedNumber: 1,
        query: {
          shopId: '', //店铺名称
          baseCode: '' //商品编码
        } //列表查询条件字段
      },
      roleType: ''
    };
  },

  methods: {
    /** 提取table公共样式 */
    tableStyle(w) {
      return {
        width: w || 80,
        'text-align': 'center',
        'white-space': 'normal',
        'word-break': 'break-all'
      };
    },

    /** 初始化表格字段 */
    initColumns() {
      return [
        { name: '店铺id', style: this.tableStyle(), customRender: (row) => <div>{ row.shopId || '——' }</div> },
        { name: '店铺名称', style: this.tableStyle(), customRender: (row) => <div>{ row.shopName || '——' }</div> },
        { name: '商品编码', style: this.tableStyle(), customRender: (row) => <div>{ row.baseCode || '——' }</div> },
        { name: '商品最低价', style: this.tableStyle(), customRender: (row) => <div>{ row.price || '——' }</div> }
      ];
    },

    /** 根据条件搜索列表数据 */
    handleSearch(params) {
      this.isLoading = true;
      this.dataForm.query = params;
      this.$refs.yTable.reload();
    },

    /** 重置列表查询条件 */
    handleReset() {
      this.isLoading = true;
      this.$refs.yTable.reload();
    },
    // 价盘导入
    valueChange(value) {
      if (value.length <= 0) return this.$root.tip('请先选择文件', 'error');
      const formData = new FormData();
      formData.append('file', value[0]);
      this.isLoading = true;
      this.$fetch({
        baseUrl: window.__CONFIG__.pinduoo_url,
        api: MALL_CODEPRICELIMIT_IMPORTRULE,
        para: formData
      }).then(() => {
        this.isLoading = false;
        this.$refs.yTable.refresh();
        this.$refs.uploadEle.$el.querySelector(`#${this.$refs.uploadEle.inputName}`).value = "";
      }).catch(() => {
        this.isLoading = false;
        this.$refs.uploadEle.$el.querySelector(`#${this.$refs.uploadEle.inputName}`).value = "";
      });
    },
    // 价盘导出
    exportData() {
      this.$fetch({
        baseUrl: window.__CONFIG__.pinduoo_url,
        api: MALL_CODEPRICELIMIT_EXPORTRULE,
        para: this.dataForm.query,
        isBlob: true,
        filename: '限价价盘',
        loading: true,
      });
    }
  },

  created() {
    this.isLoading = true;
    /// 获取角色类型
    this.$lf.getItem('menu').then((res) => {
      this.roleType = (res && res.currentRoleType && res.currentRoleType.roleTypeCode) || '';
    });
    this.$fetch({ baseUrl: window.__CONFIG__.pinduoo_url, api: MALL_GETSHOPID, para: {} }).then((res) => {
      this.formData.filter((item) => item.name === 'shopId')[0].optionData = res || [];
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.isLoading = true;
    this.$refs.yTable.refresh();
    next();
  }
};
</script>
